import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <defs>
      <rect id="a" width="40" height="40" rx="8" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g stroke="#979797" strokeWidth="1.5">
        <path d="M20 9.89v20.22M9.89 20h20.22" />
      </g>
    </g>
  </svg>
);
